import EditIcon from '@mui/icons-material/Edit';
import IconButton from 'src/components/Button/IconButton';

function UpdateDeleteLine(props) {
  return (
    <>
      <IconButton variant="contained" color="secondary" width={40} icon={<EditIcon style={{ fontSize: 25 }} onClick={props.handleOpenDialogUpdate} />} disabled={props.isVisu} />
      &nbsp;
      {props.dialogUpdate}
    </>
  );
}

export default UpdateDeleteLine;
